/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetSubjectThreadStatsDto
 */
export interface GetSubjectThreadStatsDto {
    /**
     * 
     * @type {string}
     * @memberof GetSubjectThreadStatsDto
     */
    threadId: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSubjectThreadStatsDto
     */
    participated: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetSubjectThreadStatsDto
     */
    messagesCount: number;
    /**
     * 
     * @type {number}
     * @memberof GetSubjectThreadStatsDto
     */
    newMessagesCount: number;
}

/**
 * Check if a given object implements the GetSubjectThreadStatsDto interface.
 */
export function instanceOfGetSubjectThreadStatsDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "threadId" in value;
    isInstance = isInstance && "participated" in value;
    isInstance = isInstance && "messagesCount" in value;
    isInstance = isInstance && "newMessagesCount" in value;

    return isInstance;
}

export function GetSubjectThreadStatsDtoFromJSON(json: any): GetSubjectThreadStatsDto {
    return GetSubjectThreadStatsDtoFromJSONTyped(json, false);
}

export function GetSubjectThreadStatsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSubjectThreadStatsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'threadId': json['threadId'],
        'participated': json['participated'],
        'messagesCount': json['messagesCount'],
        'newMessagesCount': json['newMessagesCount'],
    };
}

export function GetSubjectThreadStatsDtoToJSON(value?: GetSubjectThreadStatsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'threadId': value.threadId,
        'participated': value.participated,
        'messagesCount': value.messagesCount,
        'newMessagesCount': value.newMessagesCount,
    };
}

